import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "s20_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = { class: "s13 flex justify-content-right" }
const _hoisted_4 = { class: "s20 items-center gap-6 px-0 pb-6 collapse-content active" }
const _hoisted_5 = {
  key: 0,
  class: "custom-filter-set-area my-5"
}
const _hoisted_6 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_7 = { class: "form-field-floating reactive sm" }
const _hoisted_8 = { class: "form-field-floating sm" }
const _hoisted_9 = { class: "form-field-floating sm" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-field-floating reactive sm" }
const _hoisted_12 = { class: "form-field-floating reactive sm" }
const _hoisted_13 = { class: "form-field-floating reactive sm" }
const _hoisted_14 = { class: "form-field-floating reactive sm" }
const _hoisted_15 = { class: "form-field-floating sm" }
const _hoisted_16 = { class: "form-field-floating sm" }
const _hoisted_17 = { class: "table separator skin3 selection rounded" }
const _hoisted_18 = {
  class: "btn-circle",
  for: "check-list1"
}
const _hoisted_19 = ["checked"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  colspan: "5",
  class: "text-center py-5"
}
const _hoisted_22 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "selection-item" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "value"]
const _hoisted_27 = { class: "text-xl font-semibold mb-2" }
const _hoisted_28 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_29 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_30 = { class: "text-sm text-grey-600" }
const _hoisted_31 = { class: "text-sm text-grey-600" }
const _hoisted_32 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_33 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_34 = { class: "flex-right" }

import { computed, inject, onMounted, reactive, Ref, ref, watch } from 'vue';
    import axios from 'axios';
    import moment from 'moment';
    import { formatAmount, formatDate } from '@/utils';
    import { useToastStore } from '@/stores/toast.store';
    import { useConfirmationStore } from '@/stores/confirmation.store';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementInvitations',
  setup(__props) {

    const toastStore = useToastStore();
    const confirmationStore = useConfirmationStore();
    const startupInfos = reactive<{ salaires: any[] }>({ salaires: [] });
    const loading = ref(false);
    const loadingActions = ref(false);
    const collectivite = inject<Ref<any>>('collectivite');
    const itemsList = ref<any[]>([]);
    const filteredDatas = ref([] as Array<any>);
    const paginatedFilteredDatas = ref([] as Array<any>);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const filtersParams = reactive({
        name: '',
        statut_professionnel: null,
        salaires: null,
        quotite_cessible_min: null,
        quotite_cessible_max: null,
        age_min: null,
        age_max: null,
        sexe: null,
        fonction: null
    });
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return paginatedFilteredDatas.value.length > 0 && selectedItems.value.filter(i => paginatedFilteredDatas.value.findIndex(p => p.id === i) !== -1).length === paginatedFilteredDatas.value.length;
    });
    const areAllItemsSelectedValidable = computed(() => {
        return selectedItems.value.length > 0 && itemsList.value.filter(i => selectedItems.value.includes(i.id) && i.statut_prospect == 0).length === selectedItems.value.length;
    });
    const showAdvancedFilters = ref(false);

    onMounted(() => {
        fetchUnverifiedMembres();
    });

    watch(filtersParams, (oldValues, newValues) => {
        applyFilters();
        onPaginate(1);
    });

    async function fetchUnverifiedMembres(withoutLoading?: boolean) {
        try {
            if (!withoutLoading) { loading.value = true; }
            const response = await axios.get(`/backoffice/collectivites/${collectivite?.value.id}/unverified_membres`);
            itemsList.value = response.data;
            applyFilters();
            onPaginate(1);
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loading.value = false;
        }
    }

    async function sendInvitations(membreIds: any[]) {
        const confirmation = await confirmationStore.open('Validation des prospects', `Êtes-vous sûre de vouloir envoyer ${membreIds.length > 1 ? `des invitations aux ${membreIds.length} membres sélectionnés` : `une invitation au membre sélectionné`} ?`);
        if (!confirmation) return;

        try {
            loadingActions.value = true;
            await axios.post(`/backoffice/collectivites/${collectivite?.value.id}/unverified_membres/send-invitation`, { ids: membreIds });
            selectedItems.value = [];
            fetchUnverifiedMembres(true);
            toastStore.success("Invitations envoyées avec succès.");
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loadingActions.value = false;
        }
    }

    function applyFilters() {
        let allDatas = itemsList.value;

        if (filtersParams.name) {
            allDatas = allDatas.filter(a => `${a.nom} ${a.prenom}`.toLowerCase().includes(filtersParams.name.toLowerCase()));
        }
        if (filtersParams.statut_professionnel) {
            if (filtersParams.statut_professionnel == '1') {
                allDatas = allDatas.filter(a => a.retraite === false);
            } else if (filtersParams.statut_professionnel == '2') {
                allDatas = allDatas.filter(a => a.retraite === true);
            }
        }
        if (filtersParams.sexe) {
            allDatas = allDatas.filter(a => a.sexe == filtersParams.sexe);
        }
        if (filtersParams.quotite_cessible_min && !isNaN(filtersParams.quotite_cessible_min)) {
            const quotite_cessible_min = parseFloat(filtersParams.quotite_cessible_min);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant >= quotite_cessible_min);
        }
        if (filtersParams.quotite_cessible_max && !isNaN(filtersParams.quotite_cessible_max)) {
            const quotite_cessible_max = parseFloat(filtersParams.quotite_cessible_max);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant <= quotite_cessible_max);
        }
        if (filtersParams.age_min) {
            const age_min = moment(filtersParams.age_min);
            if (age_min.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrAfter(age_min);
                })
            }
        }
        if (filtersParams.age_max) {
            const age_max = moment(filtersParams.age_max);
            if (age_max.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrBefore(age_max);
                })
            }
        }
        /*if (filtersParams.salaires) {
            const matchSalaire = startupInfos.salaires[filtersParams.salaires];
            if (matchSalaire) {
                allDatas = allDatas.filter(a => !isNaN(a.salaire) && parseFloat(a.salaire) >= parseFloat(matchSalaire.salaire_min) && parseFloat(a.salaire) <= parseFloat(matchSalaire.salaire_max));
            }
        }*/
        
        filteredDatas.value = allDatas;
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        pagination.total = filteredDatas.value.length;
        pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
        const start = (page - 1) * pagination.per_page;
        paginatedFilteredDatas.value =  filteredDatas.value.slice(start, start + pagination.per_page);
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = [...selectedItems.value.filter(s => itemsList.value.findIndex(p => p.id === s) === -1), ...itemsList.value.map(i => i.id)];
        } else {
            selectedItems.value = [];
        }
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "s7_mobile container-full-2" }, [
        _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/icons/icon-info-perso.svg",
            class: "size-l",
            alt: ""
          }),
          _createTextVNode(" Invitations ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (selectedItems.value.length > 0)
          ? (_openBlock(), _createBlock(_component_custom_button, {
              key: 0,
              type: "button",
              classesList: 'btn white2 active',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sendInvitations(selectedItems.value))),
              loading: loadingActions.value
            }, {
              default: _withCtx(() => [
                _cache[12] || (_cache[12] = _createElementVNode("img", {
                  src: "/icons/icon-send.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, "Inviter (" + _toDisplayString(selectedItems.value.length) + ")", 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_custom_button, {
          type: "button",
          classesList: 'btn light',
          onClick: fetchUnverifiedMembres
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createElementVNode("img", {
              src: "/icons/icon-list.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Actualiser", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("button", {
          class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter",
          onClick: toggleAdvancedFilters
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("img", {
            src: "/icons/icon-filter.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Options", -1)
        ]))])
      ]),
      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        (showAdvancedFilters.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtersParams.name) = $event)),
                    name: "name",
                    id: "name",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, filtersParams.name]
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("label", { for: "name" }, "Nom, prénoms", -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-input-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtersParams.statut_professionnel) = $event)),
                    name: "statut_professionnel",
                    id: "statut_professionnel"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("option", { value: null }, "Tous les statuts", -1),
                    _createElementVNode("option", { value: "1" }, "Actifs", -1),
                    _createElementVNode("option", { value: "2" }, "Retraités", -1)
                  ]))], 512), [
                    [_vModelSelect, filtersParams.statut_professionnel]
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("label", { for: "statut_professionnel" }, [
                    _createTextVNode("Statut "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-input-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtersParams.salaires) = $event)),
                    name: "salaires",
                    id: "salaires"
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("option", { value: null }, "Tous les salaires", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.salaires, (salaire, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: index,
                        key: index
                      }, _toDisplayString(_unref(formatAmount)(salaire.salaire_min) + ' - ' + _unref(formatAmount)(salaire.salaire_max)), 9, _hoisted_10))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, filtersParams.salaires]
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("label", { for: "salaires" }, [
                    _createTextVNode("Salaires "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtersParams.quotite_cessible_min) = $event)),
                    name: "quotite_cessible_min",
                    id: "quotite_cessible_min",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, filtersParams.quotite_cessible_min]
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("label", { for: "quotite_cessible_min" }, "Quotité cessible >=", -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtersParams.quotite_cessible_max) = $event)),
                    name: "quotite_cessible_max",
                    id: "quotite_cessible_max",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, filtersParams.quotite_cessible_max]
                  ]),
                  _cache[21] || (_cache[21] = _createElementVNode("label", { for: "quotite_cessible_max" }, "Quotité cessible >=", -1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filtersParams.age_min) = $event)),
                    name: "age_min",
                    id: "age_min",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, filtersParams.age_min]
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("label", { for: "age_min" }, "Age >=", -1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filtersParams.age_max) = $event)),
                    name: "age_max",
                    id: "age_max",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, filtersParams.age_max]
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("label", { for: "age_max" }, "Age <=", -1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-input-select",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filtersParams.sexe) = $event)),
                    name: "sexe",
                    id: "sexe"
                  }, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("option", { value: null }, "Tous les sexes", -1),
                    _createElementVNode("option", { value: "M" }, "Masculin", -1),
                    _createElementVNode("option", { value: "F" }, "Féminin", -1)
                  ]))], 512), [
                    [_vModelSelect, filtersParams.sexe]
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("label", { for: "sexe" }, [
                    _createTextVNode("Sexe "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-input-select",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filtersParams.fonction) = $event)),
                    name: "fonction",
                    id: "fonction"
                  }, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("option", { value: null }, "Toutes les fonctions", -1)
                  ]))], 512), [
                    [_vModelSelect, filtersParams.fonction]
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("label", { for: "fonction" }, [
                    _createTextVNode("Fonction "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_17, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", _hoisted_18, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "check_all",
                    checked: areAllItemsSelected.value,
                    onChange: handleCheckAll
                  }, null, 40, _hoisted_19)
                ])
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("th", null, null, -1)),
              _cache[29] || (_cache[29] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Information")
              ], -1)),
              _cache[30] || (_cache[30] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Statut")
              ], -1)),
              _cache[31] || (_cache[31] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Date dernière invitation")
              ], -1)),
              _cache[32] || (_cache[32] = _createElementVNode("th", { class: "flex-right" }, null, -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                  _createElementVNode("td", _hoisted_21, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[33] || (_cache[33] = [
                          _createElementVNode("div", { class: "loader dark" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (paginatedFilteredDatas.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "text-center py-5"
                    }, " Aucun membre trouvé ", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginatedFilteredDatas.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "text-grey-700 over-effect over-effect-scale",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("label", {
                          class: "btn-circle",
                          for: 'item_check_' + index
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "selectedItems[]",
                            id: 'item_check_' + index,
                            value: item.id,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedItems).value = $event))
                          }, null, 8, _hoisted_26), [
                            [_vModelCheckbox, selectedItems.value]
                          ])
                        ], 8, _hoisted_25)
                      ]),
                      _cache[36] || (_cache[36] = _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "square-xl rounded-15",
                          style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
                        }, [
                          _createElementVNode("img", {
                            src: '/assets/users_avatar/600w/user.jpg',
                            width: "100%"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("p", _hoisted_27, [
                          _createTextVNode(_toDisplayString(item.nom + ' ' + item.prenom) + "   ", 1),
                          (item.actif == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Actif"))
                            : _createCommentVNode("", true),
                          (item.actif == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Inactif"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(item.email), 1),
                        _createElementVNode("p", _hoisted_31, _toDisplayString(item.telephone), 1)
                      ]),
                      _createElementVNode("td", null, [
                        (!item.email_verified_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "En attente"))
                          : _createCommentVNode("", true),
                        (item.email_verified_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Vérifié"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.last_date_invitation ? _unref(formatDate)(item.last_date_invitation) : '-'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_34, [
                          (_unref(collectivite)?.verrouille)
                            ? (_openBlock(), _createBlock(_component_custom_button, {
                                key: 0,
                                type: "button",
                                classesList: 'btn white2 active',
                                onClick: ($event: any) => (sendInvitations([item.id])),
                                loading: loadingActions.value
                              }, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-send.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }, null, -1),
                                  _createElementVNode("span", null, "Inviter", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick", "loading"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
          ])
        ]),
        _createVNode(_component_custom_pagination, {
          modelValue: queryParams.pageNumber,
          "onUpdate:modelValue": [
            _cache[11] || (_cache[11] = ($event: any) => ((queryParams.pageNumber) = $event)),
            onPaginate
          ],
          total: pagination.total,
          "per-page": pagination.per_page,
          last_page: pagination.last_page
        }, null, 8, ["modelValue", "total", "per-page", "last_page"])
      ]),
      _cache[39] || (_cache[39] = _createElementVNode("div", { class: "clear-both" }, null, -1))
    ])
  ]))
}
}

})